// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gradient-primary {
  background: rgb(216, 149, 25);
  background: linear-gradient(0deg, rgb(216, 149, 25) 0%, rgb(253, 187, 45) 100%);
}

.grayscale {
  filter: grayscale(1);
}

.danger {
  color: var(--ion-color-danger);
}

.font-primary {
  color: var(--ion-color-primary);
}

:root {
  --ion-color-primary: #f6aa1e;
  --ion-color-primary-rgb: 246, 169, 28;
  --ion-color-primary-contrast: #000000;
  --ion-color-primary-contrast-rgb: 0, 0, 0;
  --ion-color-primary-shade: #d89519;
  --ion-color-primary-tint: #f7b233;
  --ion-color-primary-light: #fcd183;
  --ion-color-secondary: #000;
  --ion-color-secondary-rgb: 0, 0, 0;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255, 255, 255;
  --ion-color-secondary-shade: #000000;
  --ion-color-secondary-tint: #1a1a1a;
  --ion-color-tertiary: #fff;
  --ion-color-tertiary-rgb: 255, 255, 255;
  --ion-color-tertiary-contrast: #000000;
  --ion-color-tertiary-contrast-rgb: 0, 0, 0;
  --ion-color-tertiary-shade: #e0e0e0;
  --ion-color-tertiary-tint: #ffffff;
  --ion-color-success: #2dd36f;
  --ion-color-success-rgb: 45, 211, 111;
  --ion-color-success-contrast: #000000;
  --ion-color-success-contrast-rgb: 0, 0, 0;
  --ion-color-success-shade: #28ba62;
  --ion-color-success-tint: #42d77d;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb: 255, 196, 9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0, 0, 0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #eb445a;
  --ion-color-danger-rgb: 235, 68, 90;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #cf3c4f;
  --ion-color-danger-tint: #ed576b;
  --ion-color-medium: #92949c;
  --ion-color-medium-rgb: 146, 148, 156;
  --ion-color-medium-contrast: #000000;
  --ion-color-medium-contrast-rgb: 0, 0, 0;
  --ion-color-medium-shade: #808289;
  --ion-color-medium-tint: #9d9fa6;
  --ion-color-light: #f5f5f5;
  --ion-color-light-rgb: 245, 245, 245;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #d8d8d8;
  --ion-color-light-tint: #f6f6f6;
  --ion-color-blue: #7CB9E8;
  --ion-color-blue-rgb: rgb(124, 185, 232);
  --ion-color-blue-contrast: #000000;
}

.gradient-primary {
  background: rgb(216, 149, 25);
  background: linear-gradient(0deg, rgb(216, 149, 25) 0%, rgb(253, 187, 45) 100%);
}

.grayscale {
  filter: grayscale(1);
}

.danger {
  color: var(--ion-color-danger);
}

:root {
  --ion-font-family: "Poppins";
  --ion-color-primary: #f6a91c;
  --ion-color-primary-rgb: 246, 169, 28;
  --ion-color-primary-contrast: #000000;
  --ion-color-primary-contrast-rgb: 0, 0, 0;
  --ion-color-primary-shade: #d89519;
  --ion-color-primary-tint: #f7b233;
  --ion-color-secondary: #000;
  --ion-color-secondary-rgb: 0, 0, 0;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255, 255, 255;
  --ion-color-secondary-shade: #000000;
  --ion-color-secondary-tint: #1a1a1a;
  --ion-color-tertiary: #fff;
  --ion-color-tertiary-rgb: 255, 255, 255;
  --ion-color-tertiary-contrast: #000000;
  --ion-color-tertiary-contrast-rgb: 0, 0, 0;
  --ion-color-tertiary-shade: #e0e0e0;
  --ion-color-tertiary-tint: #ffffff;
  --ion-color-success: #198754;
  --ion-color-success-rgb: 25, 135, 84;
  --ion-color-success-contrast: #000000;
  --ion-color-success-contrast-rgb: 0, 0, 0;
  --ion-color-success-shade: #1b6d47;
  --ion-color-success-tint: #12b86b;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb: 255, 196, 9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0, 0, 0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #eb445a;
  --ion-color-danger-rgb: 235, 68, 90;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #cf3c4f;
  --ion-color-danger-tint: #ed576b;
  --ion-color-medium: #92949c;
  --ion-color-medium-rgb: 146, 148, 156;
  --ion-color-medium-contrast: #000000;
  --ion-color-medium-contrast-rgb: 0, 0, 0;
  --ion-color-medium-shade: #808289;
  --ion-color-medium-tint: #9d9fa6;
  --ion-color-light: #fbfbfb;
  --ion-color-light-rgb: 245, 245, 245;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #d8d8d8;
  --ion-color-light-tint: #f6f6f6;
}

.onBottom {
  position: relative;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.cartItem ion-card {
  padding: 0;
  margin-left: 0;
  width: 100%;
}
.cartItem ion-card ion-img {
  max-width: 16vw;
}

.line span:not(.label) {
  font-weight: bold;
}
.line.total span {
  color: var(--ion-color-primary);
}

.trash {
  color: var(--ion-color-danger);
}

.qty-selector span {
  background-color: var(--ion-color-light);
  padding: 0.1rem 0.5rem;
}
.qty-selector .btn {
  color: var(--ion-color-primary);
}
.qty-selector .btn.left {
  border-top-left-radius: 0.4rem;
  border-bottom-left-radius: 0.4rem;
}
.qty-selector .btn.right {
  border-top-right-radius: 0.4rem;
  border-bottom-right-radius: 0.4rem;
}

button ion-badge {
  position: absolute;
  top: -0.2rem;
  right: -0.2rem;
  opacity: 0.9;
}
button ion-badge ~ ion-icon {
  margin-right: 1.2rem;
}

.event-img {
  width: 62px;
  max-width: 65px;
  height: auto;
}

ion-content {
  --ion-background-color: var(--ion-color-light);
}

ion-label {
  font-weight: 600;
  font-size: smaller;
}

ion-input,
ion-select {
  background-color: white;
  padding-left: 0.6rem !important;
  margin-top: 0.3rem !important;
  margin-bottom: 0.9rem !important;
  border: solid 1px var(--ion-color-light);
  border-radius: 0.4rem;
}
ion-input.has-focus,
ion-select.has-focus {
  border-color: var(--ion-color-primary);
}
ion-input.ng-touched.ng-invalid:not(.has-focus),
ion-select.ng-touched.ng-invalid:not(.has-focus) {
  border-color: var(--ion-color-danger);
}

@media screen and (max-width: 576px) {
  .p-45 {
    padding: 0 !important;
    padding-inline-start: 45px !important;
    padding-inline-end: 45px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/xipocio/colors.scss","webpack://./src/app/components/header/header.component.scss","webpack://./src/theme/variables.scss"],"names":[],"mappings":"AAIA;EACE,6BAAA;EACA,+EAAA;ACHF;;ADMA;EACE,oBAAA;ACHF;;ADMA;EACE,8BAAA;ACHF;;ADMA;EACE,+BAAA;ACHF;;ADMA;EACE,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EACA,kCAAA;EAEA,2BAAA;EACA,kCAAA;EACA,uCAAA;EACA,iDAAA;EACA,oCAAA;EACA,mCAAA;EAEA,0BAAA;EACA,uCAAA;EACA,sCAAA;EACA,0CAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,2BAAA;EACA,qCAAA;EACA,oCAAA;EACA,wCAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gCAAA;EACA,+BAAA;EAEA,yBAAA;EACA,wCAAA;EACA,kCAAA;ACXF;;AClEA;EACE,6BAAA;EACA,+EAAA;ADqEF;;AClEA;EACE,oBAAA;ADqEF;;AClEA;EACE,8BAAA;ADqEF;;AClEA;EACE,4BAAA;EAMA,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,kCAAA;EACA,uCAAA;EACA,iDAAA;EACA,oCAAA;EACA,mCAAA;EAEA,0BAAA;EACA,uCAAA;EACA,sCAAA;EACA,0CAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,2BAAA;EACA,qCAAA;EACA,oCAAA;EACA,wCAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gCAAA;EACA,+BAAA;ADyDF;;AApIA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAuIF;;AAnIE;EACE,UAAA;EACA,cAAA;EACA,WAAA;AAsIJ;AApII;EACE,eAAA;AAsIN;;AAhIE;EACE,iBAAA;AAmIJ;AA/HI;EACE,+BAAA;AAiIN;;AA5HA;EACE,8BAAA;AA+HF;;AA3HE;EACE,wCAAA;EACA,sBAAA;AA8HJ;AA3HE;EACE,+BAAA;AA6HJ;AA3HI;EACE,8BAAA;EACA,iCAAA;AA6HN;AA1HI;EACE,+BAAA;EACA,kCAAA;AA4HN;;AAtHE;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;AAyHJ;AAvHI;EACE,oBAAA;AAyHN;;AApHA;EACE,WAAA;EACA,eAAA;EACA,YAAA;AAuHF;;AApHA;EACE,8CAAA;AAuHF;;AApHA;EACE,gBAAA;EACA,kBAAA;AAuHF;;AApHA;;EAEE,uBAAA;EACA,+BAAA;EACA,6BAAA;EACA,gCAAA;EACA,wCAAA;EACA,qBAAA;AAuHF;AArHE;;EACE,sCAAA;AAwHJ;AArHE;;EACE,qCAAA;AAwHJ;;AApHA;EACE;IACE,qBAAA;IACA,qCAAA;IACA,mCAAA;EAuHF;AACF","sourcesContent":["$bg-color: #f5f5f5;\n$dark-gray: #333;\n$medium-gray: rgb(153, 153, 153);\n\n.gradient-primary {\n  background: rgb(216, 149, 25);\n  background: linear-gradient(0deg, rgba(216, 149, 25, 1) 0%, rgba(253, 187, 45, 1) 100%);\n}\n\n.grayscale {\n  filter: grayscale(1);\n}\n\n.danger {\n  color: var(--ion-color-danger);\n}\n\n.font-primary {\n  color: var(--ion-color-primary);\n}\n\n:root {\n  --ion-color-primary: #f6aa1e;\n  --ion-color-primary-rgb: 246, 169, 28;\n  --ion-color-primary-contrast: #000000;\n  --ion-color-primary-contrast-rgb: 0, 0, 0;\n  --ion-color-primary-shade: #d89519;\n  --ion-color-primary-tint: #f7b233;\n  --ion-color-primary-light: #fcd183;\n\n  --ion-color-secondary: #000;\n  --ion-color-secondary-rgb: 0, 0, 0;\n  --ion-color-secondary-contrast: #ffffff;\n  --ion-color-secondary-contrast-rgb: 255, 255, 255;\n  --ion-color-secondary-shade: #000000;\n  --ion-color-secondary-tint: #1a1a1a;\n\n  --ion-color-tertiary: #fff;\n  --ion-color-tertiary-rgb: 255, 255, 255;\n  --ion-color-tertiary-contrast: #000000;\n  --ion-color-tertiary-contrast-rgb: 0, 0, 0;\n  --ion-color-tertiary-shade: #e0e0e0;\n  --ion-color-tertiary-tint: #ffffff;\n\n  --ion-color-success: #2dd36f;\n  --ion-color-success-rgb: 45, 211, 111;\n  --ion-color-success-contrast: #000000;\n  --ion-color-success-contrast-rgb: 0, 0, 0;\n  --ion-color-success-shade: #28ba62;\n  --ion-color-success-tint: #42d77d;\n\n  --ion-color-warning: #ffc409;\n  --ion-color-warning-rgb: 255, 196, 9;\n  --ion-color-warning-contrast: #000000;\n  --ion-color-warning-contrast-rgb: 0, 0, 0;\n  --ion-color-warning-shade: #e0ac08;\n  --ion-color-warning-tint: #ffca22;\n\n  --ion-color-danger: #eb445a;\n  --ion-color-danger-rgb: 235, 68, 90;\n  --ion-color-danger-contrast: #ffffff;\n  --ion-color-danger-contrast-rgb: 255, 255, 255;\n  --ion-color-danger-shade: #cf3c4f;\n  --ion-color-danger-tint: #ed576b;\n\n  --ion-color-medium: #92949c;\n  --ion-color-medium-rgb: 146, 148, 156;\n  --ion-color-medium-contrast: #000000;\n  --ion-color-medium-contrast-rgb: 0, 0, 0;\n  --ion-color-medium-shade: #808289;\n  --ion-color-medium-tint: #9d9fa6;\n\n  --ion-color-light: #f5f5f5;\n  --ion-color-light-rgb: 245, 245, 245;\n  --ion-color-light-contrast: #000000;\n  --ion-color-light-contrast-rgb: 0, 0, 0;\n  --ion-color-light-shade: #d8d8d8;\n  --ion-color-light-tint: #f6f6f6;\n\n  --ion-color-blue: #7CB9E8;\n  --ion-color-blue-rgb: rgb(124, 185, 232);\n  --ion-color-blue-contrast: #000000;\n}","@import '../../../assets/xipocio/colors.scss';\n@import '../../../theme/variables.scss';\n\n.onBottom {\n  position: relative;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.cartItem {\n  ion-card {\n    padding: 0;\n    margin-left: 0;\n    width: 100%;\n\n    ion-img {\n      max-width: 16vw;\n    }\n  }\n}\n\n.line {\n  span:not(.label) {\n    font-weight: bold;\n  }\n\n  &.total {\n    span {\n      color: var(--ion-color-primary);\n    }\n  }\n}\n\n.trash {\n  color: var(--ion-color-danger);\n}\n\n.qty-selector {\n  span {\n    background-color: var(--ion-color-light);\n    padding: 0.1rem 0.5rem;\n  }\n\n  .btn {\n    color: var(--ion-color-primary);\n\n    &.left {\n      border-top-left-radius: .4rem;\n      border-bottom-left-radius: .4rem;\n    }\n\n    &.right {\n      border-top-right-radius: .4rem;\n      border-bottom-right-radius: .4rem;\n    }\n  }\n}\n\nbutton {\n  ion-badge {\n    position: absolute;\n    top: -0.2rem;\n    right: -0.2rem;\n    opacity: 0.9;\n\n    &~ion-icon {\n      margin-right: 1.2rem;\n    }\n  }\n}\n\n.event-img {\n  width: 62px;\n  max-width: 65px;\n  height: auto;\n}\n\nion-content {\n  --ion-background-color: var(--ion-color-light);\n}\n\nion-label {\n  font-weight: 600;\n  font-size: smaller;\n}\n\nion-input,\nion-select {\n  background-color: white;\n  padding-left: 0.6rem !important;\n  margin-top: 0.3rem !important;\n  margin-bottom: 0.9rem !important;\n  border: solid 1px var(--ion-color-light);\n  border-radius: .4rem;\n\n  &.has-focus {\n    border-color: var(--ion-color-primary);\n  }\n\n  &.ng-touched.ng-invalid:not(.has-focus) {\n    border-color: var(--ion-color-danger);\n  }\n}\n\n@media screen and (max-width: $phone) {\n  .p-45 {\n    padding: 0 !important;\n    padding-inline-start: 45px !important;\n    padding-inline-end: 45px !important;\n  }\n}","$bg-color: var(--ion-background-color) !important;\n$dark-gray: #333;\n$medium-gray: rgb(153, 153, 153);\n\n.gradient-primary {\n  background: rgb(216, 149, 25);\n  background: linear-gradient(0deg, rgba(216, 149, 25, 1) 0%, rgba(253, 187, 45, 1) 100%);\n}\n\n.grayscale {\n  filter: grayscale(1);\n}\n\n.danger {\n  color: var(--ion-color-danger);\n}\n\n:root {\n  --ion-font-family: 'Poppins';\n  $font-family-base: 'Poppins';\n  $font-family-ios-base: 'Poppins';\n  $font-family-md-base: 'Poppins';\n  $font-family-wp-base: 'Poppins';\n\n  --ion-color-primary: #f6a91c;\n  --ion-color-primary-rgb: 246, 169, 28;\n  --ion-color-primary-contrast: #000000;\n  --ion-color-primary-contrast-rgb: 0, 0, 0;\n  --ion-color-primary-shade: #d89519;\n  --ion-color-primary-tint: #f7b233;\n\n  --ion-color-secondary: #000;\n  --ion-color-secondary-rgb: 0, 0, 0;\n  --ion-color-secondary-contrast: #ffffff;\n  --ion-color-secondary-contrast-rgb: 255, 255, 255;\n  --ion-color-secondary-shade: #000000;\n  --ion-color-secondary-tint: #1a1a1a;\n\n  --ion-color-tertiary: #fff;\n  --ion-color-tertiary-rgb: 255, 255, 255;\n  --ion-color-tertiary-contrast: #000000;\n  --ion-color-tertiary-contrast-rgb: 0, 0, 0;\n  --ion-color-tertiary-shade: #e0e0e0;\n  --ion-color-tertiary-tint: #ffffff;\n\n  --ion-color-success: #198754;\n  --ion-color-success-rgb: 25, 135, 84;\n  --ion-color-success-contrast: #000000;\n  --ion-color-success-contrast-rgb: 0, 0, 0;\n  --ion-color-success-shade: #1b6d47;\n  --ion-color-success-tint: #12b86b;\n\n  --ion-color-warning: #ffc409;\n  --ion-color-warning-rgb: 255, 196, 9;\n  --ion-color-warning-contrast: #000000;\n  --ion-color-warning-contrast-rgb: 0, 0, 0;\n  --ion-color-warning-shade: #e0ac08;\n  --ion-color-warning-tint: #ffca22;\n\n  --ion-color-danger: #eb445a;\n  --ion-color-danger-rgb: 235, 68, 90;\n  --ion-color-danger-contrast: #ffffff;\n  --ion-color-danger-contrast-rgb: 255, 255, 255;\n  --ion-color-danger-shade: #cf3c4f;\n  --ion-color-danger-tint: #ed576b;\n\n  --ion-color-medium: #92949c;\n  --ion-color-medium-rgb: 146, 148, 156;\n  --ion-color-medium-contrast: #000000;\n  --ion-color-medium-contrast-rgb: 0, 0, 0;\n  --ion-color-medium-shade: #808289;\n  --ion-color-medium-tint: #9d9fa6;\n\n  --ion-color-light: #fbfbfb;\n  --ion-color-light-rgb: 245, 245, 245;\n  --ion-color-light-contrast: #000000;\n  --ion-color-light-contrast-rgb: 0, 0, 0;\n  --ion-color-light-shade: #d8d8d8;\n  --ion-color-light-tint: #f6f6f6;\n}\n\n// MEDIA QUERIES\n$phone: 576px;\n$tablet: 768px;\n$laptop: 992px;\n$desktop: 1200px;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
